"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var clamp = function clamp(x) {
  var low = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;
  var high = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : x;
  return Math.max(low, Math.min(high, x));
};

var _default = clamp;
exports["default"] = _default;